export type Role = {
  id: string;
  title: string;
  blurb: string;
  clues: string[];
};

export const ROLES: Role[] = [
  {
    id: "sheriff",
    title: "The Snack Sheriff",
    blurb: "Keeps the chips lawful.",
    clues: [
      "This family member once hid vegetables inside a smoothie and called it justice.",
      "They have a mental map of every crumb in the couch.",
      "They say ‘save some for later’ and then eat the later.",
      "The fridge light salutes them.",
    ],
  },
  {
    id: "aux",
    title: "Aux Goblin",
    blurb: "Controls the mood, poorly.",
    clues: [
      "This family member believes a playlist can solve a family argument.",
      "They have been caught whispering to the Bluetooth speaker.",
      "They skip sad songs like a pirate skipping chores.",
      "Karaoke is their love language, unfortunately.",
    ],
  },
  {
    id: "favorite",
    title: "Grandma’s Favorite",
    blurb: "Immune to chores. Mostly.",
    clues: [
      "This family member receives extra pie without filing paperwork.",
      "They know where the good scissors live.",
      "A cheek pinch is their ancient curse.",
      "They can do no wrong, which is statistically alarming.",
    ],
  },
  {
    id: "dog",
    title: "The Family Dog (honorary)",
    blurb: "Legally a person at game night.",
    clues: [
      "This family member understood the assignment: sit, stay, steal cheese.",
      "They communicate mostly in eyebrows.",
      "They consider the couch a full-time job.",
      "They would like to be dealt in, please.",
    ],
  },
  {
    id: "uncle",
    title: "Uncle Who Knows a Guy",
    blurb: "Every problem has a cousin.",
    clues: [
      "This family member begins stories with ‘funny you mention that’.",
      "They have a toolbox and a rumor mill.",
      "They can fix a minivan with optimism.",
      "Somebody, somewhere, owes them a sandwich.",
    ],
  },
  {
    id: "tax",
    title: "The One Who Does the Forms",
    blurb: "Brings a clipboard to game night.",
    clues: [
      "This family member color-codes leftovers.",
      "They asked if the board game had a terms of service.",
      "They know who borrowed the HDMI cable in 2018.",
      "Fun is allowed, with a receipt.",
    ],
  },
  {
    id: "baby",
    title: "Baby of the Family",
    blurb: "Age is a suggestion.",
    clues: [
      "This family member still gets a paper crown at dinner.",
      "They won an argument by being adorable, in 1999 and also yesterday.",
      "Chores bounce off them like Nerf darts.",
      "They are ‘just grabbing water’ for 45 minutes.",
    ],
  },
  {
    id: "sauce",
    title: "The Sauce Historian",
    blurb: "Protector of the Sunday pot.",
    clues: [
      "This family member can taste a bay leaf from another room.",
      "They consider ketchup a diplomatic incident.",
      "They narrate cooking like a pirate radio host.",
      "The wooden spoon is their sword.",
    ],
  },
  {
    id: "chaos",
    title: "Cousin Chaos",
    blurb: "Arrives with glitter.",
    clues: [
      "This family member has never closed a chip bag in their life.",
      "A rubber chicken follows them, unpaid.",
      "They treat Reverse cards as a personality.",
      "The smoke alarm is their hype man.",
    ],
  },
  {
    id: "couch",
    title: "Duke of the Weird Couch",
    blurb: "If they sit, the night has a king.",
    clues: [
      "This family member leaves a perfectly cousin-shaped dent.",
      "Remote control? They are the remote control.",
      "They host meetings with the cushions.",
      "Standing is a rumor they have heard about.",
    ],
  },
];

export function roleById(id: string): Role | undefined {
  return ROLES.find((r) => r.id === id);
}
